import { sendGTMEvent } from '@next/third-parties/google'

export type GtmNavBarMenuItemClickedType = {
  action?: string
  ads_title?: string
  ads_image_name?: string
  ads_url?: string
  category?: string
}

export const gtmNavbarMenuItemClicked = ({
  action,
  ads_title,
  ads_image_name,
  ads_url,
  category,
}: GtmNavBarMenuItemClickedType) => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'sho_nav_bar_shop_menu_item_clicked',
    event_id: uuid,
    action,
    category,
    ads_title,
    ads_image_name,
    ads_url,
  })
}
